<template>
  <transition-group :name="active ? transitionName : ''" @before-leave="onBeforeLeave">
    <slot></slot>
  </transition-group>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  moveableDimension?: string;
  active?: boolean;
  transitionName?: string;
}>(), {
  moveableDimension: "y",
  active: true,
  transitionName: "transition-list-flex",
});

function onBeforeLeave(el: Element | HTMLElement) {
  if (!props.active) return true;
  if (props.transitionName != "transition-list-flex") return true;
  const rect = el.getBoundingClientRect();
  const height = rect.height;
  const width = rect.width;
  if ("style" in el) {
    if (props.moveableDimension === "y") {
      el.style.marginBottom = `calc(${-height}px - var(--gap))`;
    } else {
      el.style.marginRight = `calc(${-width}px - var(--gap))`;
    }
  }
}
</script>

<style></style>
